import React, { useState } from 'react';
import { helpStyles } from '../../styles/helpStyles';
import {
  detailedRulesData,
  glossaryData,
  RuleSection,
  RuleContent,
} from '../../data/detailedRulesData';

interface DetailedRulesProps {
  initialTab?: string;
}

const tabs = [
  { id: 'basic', label: '基本' },
  { id: 'phase', label: 'フェーズ' },
  { id: 'cards', label: 'カード' },
  { id: 'battle', label: '戦闘' },
  { id: 'skills', label: '技' },
  { id: 'glossary', label: '用語集' },
];

export const DetailedRules: React.FC<DetailedRulesProps> = ({
  initialTab = 'basic',
}) => {
  const [activeTab, setActiveTab] = useState(initialTab);

  return (
    <div style={helpStyles.detailedContainer}>
      <div style={helpStyles.subTabContainer}>
        {tabs.map((tab) => (
          <button
            key={tab.id}
            onClick={() => setActiveTab(tab.id)}
            style={{
              ...helpStyles.subTab,
              ...(activeTab === tab.id
                ? helpStyles.tabActive
                : helpStyles.tabInactive),
            }}
          >
            {tab.label}
          </button>
        ))}
      </div>
      <div style={helpStyles.ruleContent}>
        {activeTab === 'glossary' ? (
          <GlossaryTable />
        ) : (
          <RuleSections sections={detailedRulesData[activeTab] || []} />
        )}
      </div>
    </div>
  );
};

interface RuleSectionsProps {
  sections: RuleSection[];
}

const RuleSections: React.FC<RuleSectionsProps> = ({ sections }) => {
  return (
    <>
      {sections.map((section, index) => (
        <div key={index} style={helpStyles.ruleSection}>
          <h4 style={helpStyles.ruleSectionTitle}>{section.title}</h4>
          {section.content.map((content, contentIndex) => (
            <RuleContentRenderer key={contentIndex} content={content} />
          ))}
        </div>
      ))}
    </>
  );
};

interface RuleContentRendererProps {
  content: RuleContent;
}

const RuleContentRenderer: React.FC<RuleContentRendererProps> = ({ content }) => {
  switch (content.type) {
    case 'text':
      return <p style={helpStyles.ruleText}>{content.content as string}</p>;

    case 'list':
      return (
        <ul style={helpStyles.ruleList}>
          {(content.content as string[]).map((item, index) => (
            <li key={index} style={helpStyles.ruleListItem}>
              {item}
            </li>
          ))}
        </ul>
      );

    case 'note':
      return <div style={helpStyles.ruleNote}>💡 {content.content as string}</div>;

    default:
      return null;
  }
};

const GlossaryTable: React.FC = () => {
  return (
    <table style={helpStyles.glossaryTable}>
      <thead>
        <tr>
          <th style={helpStyles.glossaryHeader}>用語</th>
          <th style={helpStyles.glossaryHeader}>説明</th>
        </tr>
      </thead>
      <tbody>
        {glossaryData.map((item, index) => (
          <tr key={index}>
            <td style={{ ...helpStyles.glossaryCell, ...helpStyles.glossaryTerm }}>
              {item.term}
            </td>
            <td style={helpStyles.glossaryCell}>{item.description}</td>
          </tr>
        ))}
      </tbody>
    </table>
  );
};

export default DetailedRules;
